import styled from 'styled-components';
import Select from 'react-select';
import CreatableSelect from 'react-select/creatable';

interface StyledSelectProps {
    $background?: string;
    $text?: string;
}

const baseStyles = `
    .styled__control {
        border: ${(props: StyledSelectProps) => (props.$background ? 'none' : undefined)};
        background: ${(props: StyledSelectProps) => props.$background ?? 'unset'};
    }

    .styled__single-value,
    .styled__placeholder {
        color: ${(props: StyledSelectProps) => props.$text ?? 'unset'};
        font-weight: 500;
    }
`;

export const StyledSelect = styled(Select)<StyledSelectProps>`
    ${baseStyles}
`;

export const StyledCreatableSelect = styled(CreatableSelect)<StyledSelectProps>`
    ${baseStyles}
`;
